const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSFileExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-file-export",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-file-export1",
    serifid: "iconS-file-export"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.253,14.188c-0,-0.516 0.422,-0.938 0.937,-0.938l6.563,0l-0,-5l-5,0c-0.691,0 -1.25,-0.56 -1.25,-1.25l-0,-5l-6.331,0c-1.177,-0.002 -2.419,1.116 -2.419,2.449l-0,15.022c0.006,1.422 1.255,2.518 2.524,2.529l10.007,0c1.282,-0.001 2.461,-1.201 2.469,-2.255l-0,-4.62l-6.563,0c-0.515,0 -0.937,-0.418 -0.937,-0.937Zm2.5,-12.188l-0,5l5,0l-5,-5Zm12.191,11.523l-3.125,-3.125c-0.366,-0.366 -0.959,-0.366 -1.326,0c-0.366,0.367 -0.366,0.96 0,1.326l1.56,1.526l-4.3,0l-0,1.875l4.3,0l-1.524,1.525c-0.186,0.182 -0.276,0.42 -0.276,0.663c-0,0.242 0.091,0.479 0.274,0.662c0.367,0.367 0.96,0.367 1.326,0l3.125,-3.125c0.365,-0.366 0.365,-0.959 -0.034,-1.327Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSFileExport);
export default __webpack_public_path__ + "static/media/iconS-file-export.df31b1d2d65c4b298d6812b5e9cd5b29.svg";
export { ForwardRef as ReactComponent };